import {Lens} from '../../../lenses/shared/model/lens';
import {LensSetting} from '../../../lenses/shared/model/lens-setting';

export interface LensesState {
  lenses: Lens[];
  lens: Lens;
  userLens: LensSetting;
}

export const initialLensesState: LensesState = {
  lenses: null,
  lens: null,
  userLens: null,
};
